// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JSSa","title":"Header_title__1-XJy","left":"Header_left__ET8Pw","clinicName":"Header_clinicName__1agPI"};